import {
	CellApiModule,
	CellSelectionModule,
	CellStyleModule,
	CheckboxEditorModule,
	ClientSideRowModelApiModule,
	ClientSideRowModelModule,
	ClipboardModule,
	ColumnApiModule,
	ColumnAutoSizeModule,
	ColumnMenuModule,
	ColumnsToolPanelModule,
	ContextMenuModule,
	CsvExportModule,
	CustomEditorModule,
	CustomFilterModule,
	DateEditorModule,
	DateFilterModule,
	EventApiModule,
	ExcelExportModule,
	ExternalFilterModule,
	FiltersToolPanelModule,
	GridStateModule,
	GroupFilterModule,
	LicenseManager,
	LocaleModule,
	MasterDetailModule,
	ModuleRegistry,
	MultiFilterModule,
	NumberEditorModule,
	NumberFilterModule,
	PinnedRowModule,
	PivotModule,
	QuickFilterModule,
	RenderApiModule,
	RichSelectModule,
	RowApiModule,
	RowAutoHeightModule,
	RowDragModule,
	RowGroupingModule,
	RowGroupingPanelModule,
	RowSelectionModule,
	RowStyleModule,
	ScrollApiModule,
	ServerSideRowModelApiModule,
	ServerSideRowModelModule,
	SetFilterModule,
	StatusBarModule,
	TextEditorModule,
	TextFilterModule,
	TreeDataModule,
	UndoRedoEditModule,
	ValidationModule
} from "ag-grid-enterprise";

import config from "~/config";

ModuleRegistry.registerModules([
	CellApiModule,
	CellSelectionModule,
	CellStyleModule,
	CheckboxEditorModule,
	ClientSideRowModelApiModule,
	ClientSideRowModelModule,
	ClipboardModule,
	ColumnApiModule,
	ColumnAutoSizeModule,
	ColumnMenuModule,
	ColumnsToolPanelModule,
	ContextMenuModule,
	CsvExportModule,
	CustomEditorModule,
	CustomFilterModule,
	DateEditorModule,
	DateFilterModule,
	EventApiModule,
	ExcelExportModule,
	ExternalFilterModule,
	FiltersToolPanelModule,
	GridStateModule,
	GroupFilterModule,
	LocaleModule,
	MasterDetailModule,
	MultiFilterModule,
	NumberEditorModule,
	NumberFilterModule,
	PinnedRowModule,
	PivotModule,
	QuickFilterModule,
	RenderApiModule,
	RichSelectModule,
	RowApiModule,
	RowAutoHeightModule,
	RowDragModule,
	RowGroupingModule,
	RowGroupingPanelModule,
	RowSelectionModule,
	RowStyleModule,
	ScrollApiModule,
	ServerSideRowModelApiModule,
	ServerSideRowModelModule,
	SetFilterModule,
	StatusBarModule,
	TextEditorModule,
	TextFilterModule,
	TreeDataModule,
	UndoRedoEditModule,
	ValidationModule
]);

if (config.agGridLicenseKey) {
	LicenseManager.setLicenseKey(config.agGridLicenseKey);
}
